module.exports = __webpack_public_path__ + "static/adie-camp.a9511efe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/adie-camp.jpg
// module id = 1298
// module chunks = 168707334958949